





























































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const response = computed(() => memberStore.response);

    const loading = computed(() => memberStore.loading);

    const isShowPassword = ref<boolean>(false);
    const passwordUpdateParams = computed(
      () => memberStore.passwordUpdateParams
    );
    const passwordStrengthProgress = computed(
      () => memberStore.passwordStrengthProgress
    );

    // 確認実行前からエラーメッセージが出るのを防ぐ用
    const validateUpdateActionFlag = ref<boolean>(false);

    const displayPasswordUpdateErrorFlag = computed(
      () => memberStore.displayPasswordUpdateErrorFlag
    );
    const displayPasswordUpdateError = computed(
      () => memberStore.displayPasswordUpdateError
    );

    const inputUpdatePassword = (e: string) => {
      memberStore.inputUpdatePassword(e);
      memberStore.setPasswordStrengthProgress();
      memberStore.validatePasswordUpdateParams();
    };

    const submitAction = () => {
      validateUpdateActionFlag.value = true;
      memberStore.validatePasswordUpdateParams();
      if (!displayPasswordUpdateErrorFlag.value) {
        updatePassword();
      }
    };

    const updatePassword = async () => {
      memberStore.setAuthorizationHeader(accessToken.value);
      await memberStore.updatePassword();
      if (response.value.status < 400) {
        displayuiStore.showSuccessSnackBar("パスワードの変更に成功しました。");
        memberStore.clearPasswordUpdateParams();
        memberStore.clearPasswordUpdateDisplayError();
        memberStore.clearPasswordStrengthProgress();
      }
      if (response.value.status >= 500) {
        displayuiStore.showErrorSnackBar("パスワードの変更に失敗しました。");
      } else if (response.value.status >= 400) {
        displayuiStore.showErrorSnackBar(
          "登録できないパスワードです。他のパスワードをお試しください。"
        );
      }
      memberStore.clearResponse();
    };

    onMounted(() => {
      memberStore.clearResponse();
      memberStore.clearPasswordUpdateParams();
      memberStore.clearPasswordUpdateDisplayError();
      memberStore.clearPasswordStrengthProgress();
      memberStore.setAuthorizationHeader(accessToken.value);
    });

    return {
      passwordUpdateParams,
      inputUpdatePassword,
      submitAction,
      updatePassword,
      validateUpdateActionFlag,
      displayPasswordUpdateErrorFlag,
      displayPasswordUpdateError,
      loading,
      isShowPassword,
      passwordStrengthProgress
    };
  },
  components: {}
});
